import { isMobile } from '../utils/is-mobile';

const packagesSticky = () => {
  if (!isMobile()) {
    const boxPackages = $('.js-sticky-side');
    const sidebar = boxPackages.parent();
    const sideHeight = sidebar.height();
    sidebar.height(sideHeight);
    const wrapper = $('.post-wrapper');

    if (boxPackages.length) {
      const scrollTop = $(window).scrollTop();

      if (scrollTop + $(window).height() >= sidebar.offset().top + sideHeight) {
        boxPackages.addClass('is-fixed');
      } else {
        boxPackages.removeClass('is-fixed');
      }

      if (scrollTop + $(window).height() >= wrapper.offset().top + wrapper.innerHeight()) {
        const distance = scrollTop + $(window).height() - wrapper.offset().top - wrapper.innerHeight();
        boxPackages.css('transform', `translateY(-${distance}px)`);
      } else {
        boxPackages.css('transform', 'translateY(0)');
      }
    }
  }
};

export default packagesSticky;
